<div nz-row nzType="flex">
  <div nz-col nzXs="24" nzSm="24" nzMd="20" nzLg="20" nzXl="8">
    <div class="formname">
      <b style="font-size: 13px"> {{ formTitle }} </b>
    </div>
  </div>

  <div nz-col nzXs="24" nzSm="24" nzMd="4" nzLg="6" nzXl="16" style="display: flex; justify-content: flex-end">
    <form nz-form [nzLayout]="'inline'">
      <nz-form-item>
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
          <input type="text" name="aboutsearch" [(ngModel)]="searchText" (ngModelChange)="keyup($event)"
            style="font-size: 12px !important" nz-input placeholder=" Search User" />
        </nz-input-group>
        <ng-template #suffixIconButton>
          <button (click)="search(true)" nz-button nzType="primary" style="height: 29px" nzSearch>
            <i nz-icon nzType="search"></i>
          </button>
        </ng-template>
      </nz-form-item>
      <!-- <nz-form-item>
            <button nz-button nzType="primary" (click)="add()" nzJustify="end">
              <i nz-icon nzType="plus"></i>Add New User
            </button>
          </nz-form-item> -->
    </form>
  </div>
</div>
<!-- <br /> -->
<div nz-row>
  <div nz-col nzSpan="24">
    <nz-table class="my-scroll no-wrap1" nzBordered #usermaster nzShowSizeChanger [nzFrontPagination]="false"
      [nzData]="dataList" [nzLoading]="loadingRecords" [nzSize]="'small'" [(nzPageIndex)]="pageIndex"
      [(nzPageSize)]="pageSize" [nzScroll]="{ x: '800px', y: '55vh' }" (nzPageIndexChange)="search()"
      (nzPageSizeChange)="search(true)" (nzQueryParams)="sort($event)">
      <thead>
        <tr>
          <th style="padding: 2px !important ; text-align: center" nzColumnKey="{{ 'NAME' }}" [nzSortFn]="true"
            nzWidth="150px">
            <b style="font-size: 12px !important"> User Name</b>
          </th>
          <th style="padding: 2px !important ; text-align: center" nzColumnKey="{{ 'CTC_PER_HOUR' }}" [nzSortFn]="true"
            nzWidth="26px">
            <b style="font-size: 12px !important">Rate Per Hour</b>
          </th>
          <th style="padding: 2px !important ; text-align: center" nzColumnKey="{{ 'SEQ_NO' }}" [nzSortFn]="true"
            nzWidth="27px">
            <b style="font-size: 12px !important"> Sequence No</b>
          </th>

          <th style="padding: 2px !important ; text-align: center" nzColumnKey="{{ 'IS_ACTIVE' }}" [nzSortFn]="true"
            nzWidth="20px">
            <b style="font-size: 12px !important">IS Active</b>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of usermaster.data; let i = index">
          <td style="padding: 2px; white-space: pre-line; text-align: left">
            {{ data["NAME"] }}
          </td>

          <td style="text-align: center; padding: 2px" nzWidth="120px">
            <input nz-input nzSize="small" style="font-size: 11px; " [(ngModel)]="data.CTC_PER_HOUR"
              (keypress)="numberWithDecimal($event)" type="text" maxlength="10" />
          </td>

          <td style="text-align: center; padding: 2px" nzWidth="120px">
            <input nz-input nzSize="small" style="font-size: 11px; text-align: center" [(ngModel)]="data.SEQ_NO"
              (keydown.enter)="onSeqNoChange(data, i, data.SEQ_NO)" type="text" maxlength="10" />
          </td>

          <td style="text-align: center; padding: 2px">
            <nz-switch nzSize="small" style="font-size: 11px" name="{{ i }}" [(ngModel)]="data.IS_ACTIVE"
              nzCheckedChildren="Yes" nzUnCheckedChildren="No"></nz-switch>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

 
</div>
<div nz-row nzType="flex">
  <div nz-col *ngIf="dataList.length > 0" nzSpan="24"  style="display: flex; justify-content: flex-end">
    <!-- <label for=""> {{usersData | json}}</label> -->
     
      <button nz-button style="font-size: 11px" nzType="primary" 
        (click)="ResetData()">
        Reset
      </button>
     
      <button nz-button style="font-size: 11px" nzType="primary" [nzLoading]="updateUserrecords"
        (click)="showModal()">
        Update User Data
      </button>
    
  </div>
</div>

<nz-modal [(nzVisible)]="isVisible" nzTitle="Select From Date" nzWidth="20%" (nzOnCancel)="handleCancel()">

  <ng-container *nzModalContent>
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label nzRequired nzNoColon>Applicable from </nz-form-label>

        <nz-form-control>
          <nz-date-picker style="width: 100%;" name="APPLICABLE_FROM_DATE" [nzDisabledDate]="disabledEndDate"
            nzFormat="dd/MM/yyyy" [(ngModel)]="APPLICABLE_FROM_DATE">
          </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>
  </ng-container>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Close</button>
    <button nz-button nzType="primary" (click)="UpdateUserData()" [nzLoading]="isConfirmLoading">Submit</button>
  </div>
</nz-modal>